import { useState } from "react";

import { DataContext } from "../../../Context/HelperOne";
import NavBar from "../nav_bar/Navbar";
import MonthlyAmountEntryUpdate from "./MonthlyAmountEntryUpdate";
import MonthlyAmountEntryList from "./MonthlyAmountEntryList";


const MonthlyAmountEntry = () => {

   const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)


  return (
   <div>
               <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
                   <NavBar
                       childrenPage={<MonthlyAmountEntryList />}
                       menuId={7}
                   />
               </DataContext.Provider>
           </div>
  )
}

export default MonthlyAmountEntry
